import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getAllMedicalFeedbackSurgery } from '../../../store/actions/medicalActions';
import FeedBack from './Feedback';

const mapStateToProps = ({ medicalReducer }) => ({
  results: medicalReducer.results,
});

const mapDispatchToProps = (dispatch) => bindActionCreators(
  {
    getAllMedicalFeedbackSurgery,
  },
  dispatch,
);

export default connect(mapStateToProps, mapDispatchToProps)(FeedBack);
